import { Alert, Badge, Button, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Pagination, Select, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

import CloudOffIcon from '@mui/icons-material/CloudOff';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import { FiltrosCuadrillas } from './FiltrosCuadrillas';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader'
import { getCuadrillas } from '../../services/apis';
import { useNavigate } from 'react-router-dom';
import { TablaCuadrillas } from './TablaCuadrillas';

export const Cuadrillas = () => {

    const Navigate = useNavigate();
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [fechaDesde, setFechaDesde] = useState(new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0]);
    const [fechaHasta, setFechaHasta] = useState(new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString().split('T')[0]);
    const [cuadrillas, setCuadrillas] = useState([])
    const [cuadrillasOG, setCuadrillasOG] = useState([])

    const [loaded, setLoaded] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [open, setOpen] = useState(null)
    const [openFiltros, setOpenFiltros] = useState(false)
    const [cantidadFiltros, setCantidadFiltros] = useState(0);
    // Cambia la página
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Hace que el scroll sea suave
        })

    };

    const cargarCuadrillas = async (fechaDesde, fechaHasta) => {
        try {
            const response = await getCuadrillas(fechaDesde, fechaHasta);
            console.log(response);

            if (response.success) {
                setCuadrillas(response.data)
                setCuadrillasOG(response.data)

                setLoaded(true)
            } else {
                Navigate('/')
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    useEffect(() => {
        setLoaded(false)

        cargarCuadrillas(fechaDesde, fechaHasta);
    }, [fechaDesde, fechaHasta])

    useEffect(() => {
        // Calcula el índice inicial y final de los elementos a mostrar en la página actual
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentCuadrillas = cuadrillas.slice(indexOfFirstItem, indexOfLastItem);
    }, [itemsPerPage])


    // Calcula el índice inicial y final de los elementos a mostrar en la página actual
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentCuadrillas = cuadrillas.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
        >
            <Grid
                container
                direction="row"
                justifyContent="space-around"
                alignItems="center"
                size={{ xs: 12 }}
            >
                <Grid item size={{ xs: 12, sm: 7.5, md: 8, lg: 9, xl: 10 }}>
                    <SubHeader titulo={'Partes de grupos'} />
                </Grid>

                <Grid item size={{ xs: 12, sm: 4.5, md: 4, lg: 3, xl: 2 }}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="center"
                        size={{ xs: 12 }}
                        spacing={2}
                    >
                        <TextField
                            variant='standard'
                            label='Fecha desde...'
                            type='date'
                            size='small'
                            value={fechaDesde}
                            onChange={(event) => setFechaDesde(event.target.value)}
                            InputLabelProps={{
                                shrink: true, // Esto hace que el label no se superponga con el valor
                            }}
                        />
                        <TextField
                            variant='standard'
                            label='Fecha hasta...'
                            type='date'
                            size='small'
                            value={fechaHasta}
                            onChange={(event) => setFechaHasta(event.target.value)}
                            InputLabelProps={{
                                shrink: true, // Esto hace que el label no se superponga con el valor
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="start"
                size={{ xs: 12, md: 11.5 }}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    size={{ xs: 12 }}
                >
                    {
                        loaded
                            ? <Grid
                                container
                                direction="row"
                                justifyContent={cuadrillas.length > 0 ? 'start' : 'center'}
                                alignItems={cuadrillas.length > 0 ? 'start' : 'center'}
                                size={{ xs: 12 }}
                                className='fade-in barra-scroll'
                                sx={{ overflow: 'auto', minHeight: '55vh', maxHeight: '70vh' }}
                            >
                                {cuadrillas.length > 0 ?
                                    <TablaCuadrillas currentCuadrillas={currentCuadrillas} setOpen={setOpen} open={open} />
                                    :
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        size={{ xs: 12 }}
                                        className='fade-in'
                                    >
                                        <Alert icon={<CloudOffIcon fontSize="inherit" color='warning' />} severity="warning">
                                            No se encontraron grupos.
                                        </Alert>
                                    </Grid>
                                }
                            </Grid>
                            : <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                size={{ xs: 12 }}
                                sx={{ py: 3, minHeight: '50vh' }}
                                className='fade-in'
                            >
                                <LinearProgress />

                            </Grid>
                    }
                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="end"
                    size={{ xs: 12 }}
                    sx={{ mt: 1, display: cuadrillas.length > 0 ? 'flex' : 'none' }}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="center"
                        size={{ xs: 3 }}
                    >
                        <Grid item size={{ xs: 4 }}>
                            <FormControl variant='standard' fullWidth>
                                <InputLabel id="demo-simple-select-label">Filas por pagina</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={itemsPerPage}
                                    label="Filas por pagina"
                                    onChange={(event) => setItemsPerPage(event.target.value)}
                                >
                                    <MenuItem value={25}>25</MenuItem>
                                    <MenuItem value={50}>50</MenuItem>
                                    <MenuItem value={75}>75</MenuItem>
                                    <MenuItem value={100}>100</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>

                    <Pagination
                        count={Math.ceil(cuadrillas.length / itemsPerPage)}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                        sx={{ display: cuadrillas.length > 0 && itemsPerPage < cuadrillas.length ? 'flex' : 'none' }}
                    />


                    <Grid
                        container
                        direction="row"
                        justifyContent="end"
                        alignItems="center"
                        size={{ xs: 3 }}
                        spacing={2}
                    >
                        <Badge badgeContent={cantidadFiltros} color="primary">
                            <Button variant='outlined' onClick={() => {
                                setOpenFiltros(true); console.log(openFiltros);
                            }}>
                                <FilterAltIcon sx={{ fontSize: 20, mr: 0.3, mt: -0.3 }} /> filtros
                            </Button>
                        </Badge>

                        <Button variant='outlined'>
                            <FileDownloadIcon sx={{ fontSize: 20, mr: 0.3, mt: -0.3 }} /> Exportar
                        </Button>
                    </Grid>
                </Grid>
            </Grid>



            <FiltrosCuadrillas
                open={openFiltros}
                setOpen={setOpenFiltros}
                cuadrillas={cuadrillas}
                setCuadrillas={setCuadrillas}
                cuadrillasOG={cuadrillasOG}
                cantidadFiltros={cantidadFiltros}
                setCantidadFiltros={setCantidadFiltros}
            />

        </Grid>
    )
}
